function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useState } from 'react';
import Button from '../button/button';
import { Drawer } from '../drawer/drawer';
import { PageCategoryFinder } from '../page-category-finder/page-category-finder';
export var PageCategorySelectorInput = function PageCategorySelectorInput(props) {
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    selectedPageCategory = _useState2[0],
    setSelectedPageCategory = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showDrawer = _useState4[0],
    setShowDrawer = _useState4[1];
  useEffect(function () {
    resetPageCategorySelection();
  }, [props.value]);
  function resetPageCategorySelection() {
    if (props.value) {
      setSelectedPageCategory(props.pageCategories.find(function (pc) {
        return pc.id === props.value;
      }));
    } else {
      setSelectedPageCategory(undefined);
    }
  }
  var render = function render() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
      onClick: function onClick() {
        setShowDrawer(true);
      }
    }, /*#__PURE__*/React.createElement("span", null, props.buttonLabel)), /*#__PURE__*/React.createElement(Drawer, {
      width: "60%",
      getContainer: props.getDrawerContainer,
      title: "Select Category",
      placement: "right",
      closable: true,
      submitText: "Select Category",
      destroyOnClose: true,
      disableSubmit: !selectedPageCategory,
      onSubmit: function onSubmit() {
        props.onChange(selectedPageCategory);
        setShowDrawer(false);
        setSelectedPageCategory(undefined);
      },
      onClose: function onClose() {
        if (props.onClose) {
          props.onClose();
        }
        setShowDrawer(false);
        resetPageCategorySelection();
      },
      visible: showDrawer
    }, /*#__PURE__*/React.createElement(PageCategoryFinder, {
      pageCategories: props.pageCategories,
      subscriberCounts: props.subscriberCounts,
      showEmpty: props.showEmpty,
      maxVisualDepth: 3,
      isEditable: false,
      selectedCategoryId: selectedPageCategory === null || selectedPageCategory === void 0 ? void 0 : selectedPageCategory.id,
      onCategorySelection: function onCategorySelection(cat) {
        setSelectedPageCategory(cat);
      }
    })));
  };
  return render();
};